import axiosConfig from "config/axiosConfig";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import UrlImage from "config/UrlImage";

function CardCategoryArticle() {
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState([]);

  useEffect(() => {
    let isMounted = true;

    axiosConfig.get(`/api/getCategories`).then((res) => {
      if (isMounted) {
        if (res.data.status === 200) {
          setCategory(res.data.category);
          setLoading(false);
        }
      }
    });
    return () => {
      isMounted = false;
    };
  }, []);

  const countData = category.length
  if (loading) {
    return (
      <div className="text-center">
        <div className="spinner-grow text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  } else {
    if (countData < 1) {
      return (
        <div className="col-md-12 py-5 px-5 text-center">
          <h4>Belum ada data kategori</h4>
        </div>
      )
    } else {

      var showListcategory = "";
      showListcategory = category.map((item) => {
        return (
          // <div className="col-12 col-md-4 col-lg-3" key={item.id}>
          //   <div className="card mb-4">
          //     <div className="card-body">
          //       <Link to="/" className="component-content d-block">
          //         <div className="content-thumbnail">
          //           <div className="content-image">
          //             <Link to={`/tutorial/${item.slug}`}></Link>
          //           </div>
          //         </div>
          //         <div className="content-title">
          //           <Link to={`/tutorial/${item.slug}`}>{item.name}</Link>
          //         </div>
          //       </Link>
          //       <div className="divider"></div>
          //       <div className="author">
          //         <div className="author-profile">
          //           <img
          //             src={userIcon}
          //             className="profile-picture rounded-circle"
          //             alt=""
          //           />
          //           <p className="author-name">Author</p>
          //         </div>
          //       </div>
          //     </div>
          //   </div>
          // </div>

          <div
            className="col-lg-4 col-md-6 d-flex align-items-stretch mt-3"
            data-aos="zoom-in"
            data-aos-delay="100"
            key={item.id}
          >
            <div className="icon-box iconbox-blue">
              <Link to={`/tutorial/${item.slug}`}>
                <div className="icon">
                  <img
                    src={`${UrlImage}/${item.image}`}
                    className="img-fluid"
                    alt=""
                    style={{ width: 100, height: 100 }}
                  />
                </div>
              </Link>
              <h4>
                <Link to={`/tutorial/${item.slug}`}>{item.name}</Link>
              </h4>
              <p>
                Voluptatum deleniti atque corrupti quos dolores et quas molestias
                excepturi
              </p>
            </div>
          </div>
        );
      });

    }

  }
  return <div className="row">{showListcategory}</div>;
}

export default CardCategoryArticle;
